module.exports = __webpack_public_path__ + "b19d4a42dd4628e0e8df1ddeb63f9d52.mtl";